<script lang="ts">
import { defineComponent, reactive } from 'vue'
import SolutionPageWrapper from '@/components/solutions/SolutionPageWrapper.vue'
import LayoutSolutionContentsCards from '@/components/solutions/LayoutSolutionContentsCards.vue'
import PaginationDefault from '@/components/pagination/PaginationDefault.vue'
import stateInitializer from '@/models/stateInitializer'
import paginationModel from '@/models/pagination'

export default defineComponent({
  name: 'SolutionDocumentsMain',

  components: {
    SolutionPageWrapper,
    LayoutSolutionContentsCards,
    PaginationDefault,
  },

  setup() {
    interface State {
      solution: {
        id: number | undefined,
      },

      documents: SolutionContentItem[],

      tab: {
        hasDocuments: boolean,
        hasVideos: boolean,
      },

      pagination: Pagination,
    }

    const state: State = reactive({
      solution: {
        id: undefined,
      },

      documents: [],

      tab: {
        hasDocuments: false,
        hasVideos: false,
      },

      pagination: {
        page: 0,
        per: 0,
        totalCount: 0,
      },
    })

    stateInitializer(state, 'main')

    const { pagination } = paginationModel(state.pagination)

    return {
      // data
      state,

      // computed
      pagination,
    }
  },
})
</script>

<template>
  <SolutionPageWrapper
    :id="state.solution.id"
    current-tab-key="documents"
    :tab-option="state.tab">
    <template #description>
      <LayoutSolutionContentsCards
        :items="state.documents"
        :cols="{ pc: 1, sp: 1 }"
        :horizontal="{
          pc: true,
          sp: true,
        }" />
    </template>

    <template #pagination>
      <PaginationDefault
        :page="pagination.page"
        :offset="4"
        :total-page="pagination.totalPage || 0" />
    </template>
  </SolutionPageWrapper>
</template>
